// extracted by mini-css-extract-plugin
export var colorSquare = "_qv-0";
export var danger = "_qv-5";
export var lightPink = "_qv-8";
export var neutralBlue = "_qv-7";
export var neutralYellow = "_qv-6";
export var normal = "_qv-1";
export var primary = "_qv-2";
export var primaryLight = "_qv-3";
export var solidBlack = "_qv-g";
export var solidGreen = "_qv-b";
export var solidLightBlue = "_qv-d";
export var solidNavy = "_qv-c";
export var solidOrange = "_qv-f";
export var solidPink = "_qv-e";
export var solidRed = "_qv-9";
export var solidYellow = "_qv-a";
export var success = "_qv-4";